import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ButtonTooltip } from 'src/app/domain/shared/component/buttons/button.component';

@Component({
  selector: 'app-all-icons',
  templateUrl: './all-icons.component.html',
  styleUrls: ['./all-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Each icon has @param iconNameAndStyling, which can be set as only icon name placed inside
 * the folder with @const ICONS_FOLDER_PATH or also as icon name with some classes which will
 * be applied to the icon written in one string with semicolons ';' as delimeter.
 *
 * E.g. iconNameAndStyling = 'copy.svg' will just use copy.svg icon without any additional classes
 * iconNameAndStyling = 'copy.svg; opacity0p64; width-3; height-3' will use copy.svg icon with
 * class="opacity0p64 width-3 height-3" applied to it's div wrapper.
 */
export class AllIconsComponent implements OnChanges {
  @Input() iconNameAndStyling: string;
  @Input() inputStyling: string;
  @Input() buttonTooltip: ButtonTooltip;
  @Input() href: string;
  folderPath = ICONS_FOLDER_PATH;
  iconName: string;
  styling: string;
  showTooltip = false;
  tooltipCoordinates: DOMRect;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.iconNameAndStyling) {
      this.styling = undefined;
      const iconNameWithStyles = this.iconNameAndStyling.split(';');
      this.iconName = iconNameWithStyles[0];
      if (iconNameWithStyles.length > 1) {
        iconNameWithStyles.splice(0, 1); // remove icon name from array
        this.styling = iconNameWithStyles.join(' ');
      }
    }
  }

  activateTooltip(): void {
    if (!this.buttonTooltip?.showCondition) {
      return;
    }
    this.tooltipCoordinates = document.getElementById(this.buttonTooltip.id).getBoundingClientRect();
    this.showTooltip = true;
  }
}

export const ICONS_FOLDER_PATH = '/assets/svg/optimized/';
